<template>
  <section
    :class="{ 'disabledSelect': disableDropDown || completed || showOptions}"
  >
    <label
      v-if="label"
      v-text="label"
    >
    </label>
    <div
      id="select"
      :class="[{'alert': alert}, 'select']"
      @click="openDropDown"
    >
      <div>
        <blinking-cursor-text
          v-if="blinkingText"
          :text="blinkingText"
          :text-step="stepIndex"
        ></blinking-cursor-text>
      </div>
      <div class="arrow">
        <div></div>
      </div>
    </div>
    <div
      class="options-container"
      v-if="answers"
    >
      <div
        class="option"
        v-for="(option, index) in displayOptions"
        :key="index"
        track-by="$index"
        @click="selectOption(option)"
      >
        <p
          v-text="option.text"
        ></p>
      </div>
    </div>
  </section>
</template>

<script>
import TweenMax from 'gsap';
import BlinkingCursorText from './BlinkingCursorText.vue';
import CommonAudio from '../../mixins/CommonAudio';

export default {
  props: {
    options: {
      type: Array,
      default: () => [],
      required: true
    },
    dropdownId: {
      type: String,
      default: '',
      required: true
    },
    completed: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    selectedCorrect: {
      type: Function,
      default: () => {}
    },
    stepIndex: {
      type: Number,
      required: true
    },
    disableDropDown: {
      type: Boolean,
      default: false
    },
    showOptions: {
      type: Boolean,
      default: false
    }
  },

  components: {
    BlinkingCursorText
  },

  mixins: [CommonAudio],

  data() {
    return {
      answers: false,
      blinkingText: false,
      alert: false
    };
  },
  computed: {
    displayOptions() {
      return this.answers ? this.options : [];
    }
  },
  methods: {
    openDropDown() {
      if (this.disableDropDown || this.completed || this.blinkingText || this.showOptions) return;
      this.answers = !this.answers;
      this.selectedCorrect();
    },
    selectOption(option) {
      if (option.isValid) {
        this.blinkingText = option.text;
        this.answers = false;
        this.alert = false;
        this.selectedCorrect(this.stepIndex);
        return this.sndBell();
      }
      this.alert = true;
      TweenMax.delayedCall(0.6, () => { this.alert = false; });
      this.sndError();
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
$disabled-color: lighten(gray, 20%);

section{
  margin: 2% 0;
  .select{
    display: block;
    border: 2px solid black;
    cursor: pointer;
    height: 30px;
    > div{
      display: inline-block;
      max-width: 50%;
    }
    &.alert{
      background-color: red;
      .arrow{
        background-color: white;
      }
    }
    p{
      display: inline-block;
      margin: 2.5% 3%;
      white-space: nowrap;
      font-size: 0.92rem;
      span{
        color: red;
      }
    }
    .arrow{
      float: right;
      border-left: 1px solid #000;
      width: 35px;
      height: 30px;
      cursor: pointer;
      > div{
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 10px solid #000;
        margin-top: 9px;
        margin-left: 11px;
      }
    }
  }
  .options-container{
    position: absolute;
    width: 578px;
    z-index: 1;
    background-color: grey;
    cursor: pointer;

    .option{
      &:hover {
        background-color: black;
        transition-duration: 0.5s;
      }
      p{
        color: black;
        &:hover{
          color: white;
        }
      }
    }
  }
  .disabledSelect{
    color: $disabled-color;
    .select{
      border-color: $disabled-color;
      color: $disabled-color;
      cursor: default;
      .arrow{
        border-left: 1px solid $disabled-color;
        > div{
          border-top: 10px solid $disabled-color;
        }
      }
    }
  }
  label{
    display: block;
    margin: 1% 0;
  }
}
</style>
